export interface RoadmapPhase {
  id: string;
  name: string;
  status: 'completed' | 'in-progress' | 'planned';
  tasks: RoadmapTask[];
}

export interface RoadmapTask {
  id: string;
  name: string;
  status: 'done' | 'todo';
}

export const roadmapData: RoadmapPhase[] = [
  {
    id: 'phase-1',
    name: 'Phase 1: Core Foundation',
    status: 'completed',
    tasks: [
      { id: 'p1-t1', name: 'Grid simulation system (180x120)', status: 'done' },
      { id: 'p1-t2', name: 'Basic elements: Sand, Water, Stone, Fire, Wood', status: 'done' },
      { id: 'p1-t3', name: 'Temperature system with phase changes', status: 'done' },
      { id: 'p1-t4', name: 'Canvas rendering with cell-based display', status: 'done' },
      { id: 'p1-t5', name: 'Brush tool with variable size', status: 'done' },
      { id: 'p1-t6', name: 'Play/Pause simulation control', status: 'done' },
    ],
  },
  {
    id: 'phase-2',
    name: 'Phase 2: Material & Spell Expansion',
    status: 'completed',
    tasks: [
      { id: 'p2-t1', name: 'Extended material roster (20+ elements)', status: 'done' },
      { id: 'p2-t2', name: 'Core spells: Tornado, Lightning, Meteor, Black Hole', status: 'done' },
      { id: 'p2-t3', name: 'Rain Cloud spell', status: 'done' },
      { id: 'p2-t4', name: 'Bomb spell with explosion', status: 'done' },
      { id: 'p2-t5', name: 'Save/Load system (JSON format)', status: 'done' },
      { id: 'p2-t6', name: 'Screen shake effects', status: 'done' },
    ],
  },
  {
    id: 'phase-3',
    name: 'Phase 3: New Elements & Spells',
    status: 'completed',
    tasks: [
      { id: 'p3-t1', name: 'NEW: Wax element (melts when heated)', status: 'done' },
      { id: 'p3-t2', name: 'NEW: Fuse element (slow-burning timing)', status: 'done' },
      { id: 'p3-t3', name: 'NEW: Coal element (long-burning fuel)', status: 'done' },
      { id: 'p3-t4', name: 'NEW: Salt element (dissolves in water)', status: 'done' },
      { id: 'p3-t5', name: 'NEW: Slime element (bouncy, sticky)', status: 'done' },
      { id: 'p3-t6', name: 'NEW: Magma element (heavier lava)', status: 'done' },
      { id: 'p3-t7', name: 'NEW: Electric Spark element', status: 'done' },
      { id: 'p3-t8', name: 'NEW: Freeze Ray spell', status: 'done' },
      { id: 'p3-t9', name: 'NEW: Earthquake spell', status: 'done' },
      { id: 'p3-t10', name: 'NEW: Tsunami spell', status: 'done' },
    ],
  },
  {
    id: 'phase-4',
    name: 'Phase 4: Visual & Audio Enhancements',
    status: 'completed',
    tasks: [
      { id: 'p4-t1', name: 'Glow effects for hot elements', status: 'done' },
      { id: 'p4-t2', name: 'Enhanced spell visual effects', status: 'done' },
      { id: 'p4-t3', name: 'Procedural audio system (Web Audio API)', status: 'done' },
      { id: 'p4-t4', name: 'Sound effects for elements and spells', status: 'done' },
      { id: 'p4-t5', name: 'Audio settings panel', status: 'done' },
    ],
  },
  {
    id: 'phase-5',
    name: 'Phase 5: Performance & UI',
    status: 'completed',
    tasks: [
      { id: 'p5-t1', name: 'Chunk-based update system', status: 'done' },
      { id: 'p5-t2', name: 'Sleep/wake optimization', status: 'done' },
      { id: 'p5-t3', name: 'Settings panel with graphics options', status: 'done' },
      { id: 'p5-t4', name: 'Simulation speed control', status: 'done' },
      { id: 'p5-t5', name: 'Pre-built scenes selector', status: 'done' },
      { id: 'p5-t6', name: 'Element tooltips and descriptions', status: 'done' },
      { id: 'p5-t7', name: 'Used elements tracking', status: 'done' },
    ],
  },
  {
    id: 'phase-6',
    name: 'Phase 6: Future Features',
    status: 'planned',
    tasks: [
      { id: 'p6-t1', name: 'Creature summoning system', status: 'todo' },
      { id: 'p6-t2', name: 'Whomping Willow creature', status: 'todo' },
      { id: 'p6-t3', name: 'Troll Smasher creature', status: 'todo' },
      { id: 'p6-t4', name: 'Achievements/Discoveries system', status: 'todo' },
      { id: 'p6-t5', name: 'Export to GIF/Video', status: 'todo' },
      { id: 'p6-t6', name: 'Mobile touch improvements', status: 'todo' },
    ],
  },
];
